(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-blog-posts"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('featured-blog-arrows')) {
    customElements.define(
      'featured-blog-arrows',
      class extends HTMLElement {
        connectedCallback() {
          this.previousButton = this.querySelector('[ref="previous"]');
          this.nextButton = this.querySelector('[ref="next"]');
          // Strip the declarative handlers — they only resolve inside slideshow-component
          this.previousButton?.removeAttribute('on:click');
          this.nextButton?.removeAttribute('on:click');

          this.previousButton?.addEventListener('click', (event) => this.slideshow?.previous(event));
          this.nextButton?.addEventListener('click', (event) => this.slideshow?.next(event));

          this.onSelect = () => requestAnimationFrame(() => this.update());
          this.section = this.closest('.shopify-section');
          this.section?.addEventListener('slideshow:select', this.onSelect);
          customElements.whenDefined('slideshow-component').then(() => this.update());
        }

        disconnectedCallback() {
          this.section?.removeEventListener('slideshow:select', this.onSelect);
        }

        get slideshow() {
          return this.section?.querySelector('slideshow-component');
        }

        update() {
          const slideshow = this.slideshow;
          const slides = slideshow?.slides;
          if (!slideshow || !slides || slideshow.infinite) return;
          if (this.previousButton) this.previousButton.disabled = slideshow.current === 0;
          if (this.nextButton) this.nextButton.disabled = slideshow.nextIndex >= slides.length;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["title-and-text"] && !Shopify.designMode) return;
  try {
    
    jQuery(() => {
        if($('.scroll-to').length) {
            $('.scroll-to').on('click', function(event) {
                event.preventDefault();
                const target = $(this).attr('href');
                if (target.startsWith('#')) {
                    $('html, body').animate({
                        scrollTop: $(target).offset().top - 200
                    }, 500);
                } else {
                    window.location.href = target;
                }
            });
        }
    });

  } catch(e) { console.error(e); }
})();
})();
